export type EngagementActionType = "REBRAND" | "REVIEW" | "APPROVE";

export class EngagementAction {
  id: number;
  type: EngagementActionType;
  sequence: number;
  assigned_roles: string[];
  is_active: boolean;
  completed_at: string | null;
  completed_by_id: number | null;
  todo_id: number;
  engagement_id: number;
  engagement_name: string;
  launch_ad_id: number;
  launch_name: string;
  ad_name: string;

  constructor(data?: Partial<EngagementAction>) {
    this.id = data?.id ?? 0;
    this.type = (data?.type ?? "APPROVE") as EngagementActionType;
    this.sequence = data?.sequence ?? 0;
    this.assigned_roles = data?.assigned_roles ?? [];
    this.is_active = data?.is_active ?? false;
    this.completed_at = data?.completed_at ?? null;
    this.completed_by_id = data?.completed_by_id ?? null;
    this.todo_id = data?.todo_id ?? 0;
    this.engagement_id = data?.engagement_id ?? 0;
    this.engagement_name = data?.engagement_name ?? "";
    this.launch_ad_id = data?.launch_ad_id ?? 0;
    this.launch_name = data?.launch_name ?? "";
    this.ad_name = data?.ad_name ?? "";
  }
}
